module.exports = __webpack_public_path__ + "static/media/news-illustration.769f8d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/news-illustration.png
// module id = 1641
// module chunks = 27